// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__33bhd","label":"Category_label__zyMpV","content":"Category_content__2kXok","header":"Category_header__37OqF","location":"Category_location__1Mlpf"};